import { createLabeledMessages } from '../../../messageUtils';
const speedMeter = {
    speedTest: 'Meranie rýchlosti',
    connectionProblem: 'Problém s pripojením na internet',
    repeatTest: 'Opakovať test',
    excellent: 'Vynikajúca',
    sufficient: 'Dostatočná',
    insufficient: 'Nedostatočná',
    connectionSpeed: 'Rychlosť pripojenia je',
    errorDuringTest: 'Pri meraní se vyskytla chyba',
    download: 'Download',
    upload: 'Upload',
    ping: 'Ping',
    mbs: 'MB/s',
    ms: 'ms',
    badResponse: 'Server vrátil zlú odpoveď – chyba nie je na Vašej strane',
    connectionLost: 'Pripojenie k internetu bolo stratené'
};
export default Object.assign({}, speedMeter, createLabeledMessages(speedMeter));
